export default class CreditsListController {
    constructor($routeParams, auditService, subscriptionsService, $window) {
        this.$window = $window;
        this.audits = {};
        this.creditsCourse = 0;
        this.creditsTrainee = 0;
        this.$routeParams = $routeParams;

        subscriptionsService.getCreditsForSubscription(this.$routeParams.subscriptionId).then(resp => {
            this.creditsCourse = resp.data.creditsCourse;
            this.creditsTrainee = resp.data.creditsTrainee;
        })

        auditService.getAuditsForUser(this.$routeParams.subscriptionId).then(resp => {
            this.audits = resp.data;
        });

        this.printAsPDF = function() {
            window.print();
        }



    }


}



// WEBPACK FOOTER //
// ./src/js/components/credits/credits.list.controller.js